import MapWrapper from '../../map-wrapper';
import './style.scss';
import './style-old.scss';
import StoreList from './store-list';
import FeatureFilters from './feature-filters';
import StoreCards from '../../store-cards';

export default function OldOni() {
    return (
        <div className="old-oni">
            <div className="row">
                <div className="col-md-4">
                    <FeatureFilters />
                </div>
                <div className="col-md-8">
                    <MapWrapper style={{ height: '556px', marginBottom: '20px', overflow: 'hidden' }} />

                    <StoreCards render={StoreList} />
                </div>
            </div>
        </div>
    );
}
